import day1 from 'images/ppfPreview/day_1'
import day2 from 'images/ppfPreview/day_2'
import day3 from 'images/ppfPreview/day_3'
import day4 from 'images/ppfPreview/day_4'
import day5 from 'images/ppfPreview/day_5'
import day6 from 'images/ppfPreview/day_6'
import day8 from 'images/ppfPreview/day_8'
import day10 from 'images/ppfPreview/day_10'
import day12 from 'images/ppfPreview/day_12'
import day15 from 'images/ppfPreview/day_15'
import day18 from 'images/ppfPreview/day_18'
import day20 from 'images/ppfPreview/day_20'
import day22 from 'images/ppfPreview/day_22'
import day25 from 'images/ppfPreview/day_25'
import day28 from 'images/ppfPreview/day_28'
import day30 from 'images/ppfPreview/day_30'
import day32 from 'images/ppfPreview/day_32'
import day35 from 'images/ppfPreview/day_35'
import day38 from 'images/ppfPreview/day_38'
import day40 from 'images/ppfPreview/day_40'
import day45 from 'images/ppfPreview/day_45'
import day50 from 'images/ppfPreview/day_50'
import day55 from 'images/ppfPreview/day_55'
import day60 from 'images/ppfPreview/day_60'
import day65 from 'images/ppfPreview/day_65'
import day70 from 'images/ppfPreview/day_70'
import day75 from 'images/ppfPreview/day_75'
import day80 from 'images/ppfPreview/day_80'
import day90 from 'images/ppfPreview/day_90'
import day100 from 'images/ppfPreview/day_100'
import day110 from 'images/ppfPreview/day_110'
import day130 from 'images/ppfPreview/day_130'
import day150 from 'images/ppfPreview/day_150'
import day200 from 'images/ppfPreview/day_200'
import night1 from 'images/ppfPreview/night_1'
import night2 from 'images/ppfPreview/night_2'
import night3 from 'images/ppfPreview/night_3'
import night4 from 'images/ppfPreview/night_4'
import night5 from 'images/ppfPreview/night_5'
import night6 from 'images/ppfPreview/night_6'
import night8 from 'images/ppfPreview/night_8'
import night10 from 'images/ppfPreview/night_10'
import night12 from 'images/ppfPreview/night_12'
import night15 from 'images/ppfPreview/night_15'
import night18 from 'images/ppfPreview/night_18'
import night20 from 'images/ppfPreview/night_20'
import night22 from 'images/ppfPreview/night_22'
import night25 from 'images/ppfPreview/night_25'
import night28 from 'images/ppfPreview/night_28'
import night30 from 'images/ppfPreview/night_30'
import night32 from 'images/ppfPreview/night_32'
import night35 from 'images/ppfPreview/night_35'
import night38 from 'images/ppfPreview/night_38'
import night40 from 'images/ppfPreview/night_40'
import night45 from 'images/ppfPreview/night_45'
import night50 from 'images/ppfPreview/night_50'
import night55 from 'images/ppfPreview/night_55'
import night60 from 'images/ppfPreview/night_60'
import night65 from 'images/ppfPreview/night_65'
import night70 from 'images/ppfPreview/night_70'
import night75 from 'images/ppfPreview/night_75'
import night80 from 'images/ppfPreview/night_80'
import night90 from 'images/ppfPreview/night_90'
import night100 from 'images/ppfPreview/night_100'
import night110 from 'images/ppfPreview/night_110'
import night130 from 'images/ppfPreview/night_130'
import night150 from 'images/ppfPreview/night_150'
import night200 from 'images/ppfPreview/night_200'
import ir1 from 'images/ppfPreview/ir_1'
import ir2 from 'images/ppfPreview/ir_2'
import ir3 from 'images/ppfPreview/ir_3'
import ir4 from 'images/ppfPreview/ir_4'
import ir5 from 'images/ppfPreview/ir_5'
import ir6 from 'images/ppfPreview/ir_6'
import ir8 from 'images/ppfPreview/ir_8'
import ir10 from 'images/ppfPreview/ir_10'
import ir12 from 'images/ppfPreview/ir_12'
import ir15 from 'images/ppfPreview/ir_15'
import ir18 from 'images/ppfPreview/ir_18'
import ir20 from 'images/ppfPreview/ir_20'
import ir22 from 'images/ppfPreview/ir_22'
import ir25 from 'images/ppfPreview/ir_25'
import ir28 from 'images/ppfPreview/ir_28'
import ir30 from 'images/ppfPreview/ir_30'
import ir32 from 'images/ppfPreview/ir_32'
import ir35 from 'images/ppfPreview/ir_35'
import ir38 from 'images/ppfPreview/ir_38'
import ir40 from 'images/ppfPreview/ir_40'
import ir45 from 'images/ppfPreview/ir_45'
import ir50 from 'images/ppfPreview/ir_50'
import ir55 from 'images/ppfPreview/ir_55'
import ir60 from 'images/ppfPreview/ir_60'
import ir65 from 'images/ppfPreview/ir_65'
import ir70 from 'images/ppfPreview/ir_70'
import ir75 from 'images/ppfPreview/ir_75'
import ir80 from 'images/ppfPreview/ir_80'
import ir90 from 'images/ppfPreview/ir_90'
import ir100 from 'images/ppfPreview/ir_100'
import ir110 from 'images/ppfPreview/ir_110'
import ir130 from 'images/ppfPreview/ir_130'
import ir150 from 'images/ppfPreview/ir_150'
import ir200 from 'images/ppfPreview/ir_200'
import low1 from 'images/ppfPreview/low_1'
import low2 from 'images/ppfPreview/low_2'
import low3 from 'images/ppfPreview/low_3'
import low4 from 'images/ppfPreview/low_4'
import low5 from 'images/ppfPreview/low_5'
import low6 from 'images/ppfPreview/low_6'
import low8 from 'images/ppfPreview/low_8'
import low10 from 'images/ppfPreview/low_10'
import low12 from 'images/ppfPreview/low_12'
import low15 from 'images/ppfPreview/low_15'
import low18 from 'images/ppfPreview/low_18'
import low20 from 'images/ppfPreview/low_20'
import low22 from 'images/ppfPreview/low_22'
import low25 from 'images/ppfPreview/low_25'
import low28 from 'images/ppfPreview/low_28'
import low30 from 'images/ppfPreview/low_30'
import low32 from 'images/ppfPreview/low_32'
import low35 from 'images/ppfPreview/low_35'
import low38 from 'images/ppfPreview/low_38'
import low40 from 'images/ppfPreview/low_40'
import low45 from 'images/ppfPreview/low_45'
import low50 from 'images/ppfPreview/low_50'
import low55 from 'images/ppfPreview/low_55'
import low60 from 'images/ppfPreview/low_60'
import low65 from 'images/ppfPreview/low_65'
import low70 from 'images/ppfPreview/low_70'
import low75 from 'images/ppfPreview/low_75'
import low80 from 'images/ppfPreview/low_80'
import low90 from 'images/ppfPreview/low_90'
import low100 from 'images/ppfPreview/low_100'
import low110 from 'images/ppfPreview/low_110'
import low130 from 'images/ppfPreview/low_130'
import low150 from 'images/ppfPreview/low_150'
import low200 from 'images/ppfPreview/low_200'

export default { day1, day2, day3, day4, day5, day6, day8, day10, day12, day15, day18, day20,
  day22, day25, day28, day30, day32, day35, day38, day40, day45, day50, day55,
  day60, day65, day70, day75, day80, day90, day100, day110, day130, day150, day200,
  night1, night2, night3, night4, night5, night6, night8, night10, night12, night15, night18, night20,
  night22, night25, night28, night30, night32, night35, night38, night40, night45, night50, night55,
  night60, night65, night70, night75, night80, night90, night100, night110, night130, night150, night200,
  ir1, ir2, ir3, ir4, ir5, ir6, ir8, ir10, ir12, ir15, ir18, ir20,
  ir22, ir25, ir28, ir30, ir32, ir35, ir38, ir40, ir45, ir50, ir55,
  ir60, ir65, ir70, ir75, ir80, ir90, ir100, ir110, ir130, ir150, ir200,
  low1, low2, low3, low4, low5, low6, low8, low10, low12, low15, low18, low20,
  low22, low25, low28, low30, low32, low35, low38, low40, low45, low50, low55,
  low60, low65, low70, low75, low80, low90, low100, low110, low130, low150, low200 }



// WEBPACK FOOTER //
// ./src/helpers/ppfPreview/previewImages.js